import React from 'react';
import './Checkbox.scss';

/**
 *
 */
interface ICheckboxProps {

  position?: 'start' | 'end';
}

/**
 *
 */
export const Checkbox = React.forwardRef(
  (
    props: ICheckboxProps & React.InputHTMLAttributes<HTMLInputElement>,
    ref: React.Ref<any>
  ): JSX.Element => {

    const {
      children,
      ...rest
    } = props;

    return (
      <div className="checkbox-wrapper relative flex align-center" position-end={props.position === 'end' ? '' : null}>
        <input className="absolute width-100 height-100" type="checkbox" {...rest} ref={ref} />
        <span className="checkmark absolute inline-block vertical-align-middle"></span>
        <span className="check-text inline-block vertical-align-middle">{props.children}</span>
      </div>
    );
  }
);